<div *ngIf="coach">
  <mat-card>
    <mat-card-content class="pb-0">
      <div class="d-flex mb-3 main-coach">
        <div><img [src]="imageSrc || '../../../../assets/images/userprofile.jpg'" alt="userprofile"></div>
        <mat-card-header>
          <mat-card-title><b>{{ coach.fullname }}</b></mat-card-title>
          <mat-card-subtitle>Coach</mat-card-subtitle>
        </mat-card-header>
      </div>
      <div class="detail-coach">
        <div class="d-flex row">
          <div class="col-1">Email</div>
          <div class="col-1">:</div>
          <div class="col-2">{{ coach.email }}</div>
        </div>
        <div class="d-flex row">
          <div class="col-1">Username</div>
          <div class="col-1">:</div>
          <div class="col-2">{{ coach.username }}</div>
        </div>
        <div class="d-flex row">
          <div class="col-1">School</div>
          <div class="col-1">:</div>
          <div class="col-2">{{ coach.school_short_address }}</div>
        </div>
      </div>
    </mat-card-content>
    <div class="p-3">
      <button class="btn btn-warning mt-3" (click)="onOpenModalEditCoach()">Edit</button>
    </div>
  </mat-card>

  <div class="d-grid mb-2">
    <span style="font-size: 20px; font-weight: bold; color: #333;" class="mb-2">Coaching Detail</span>
    <table class="table table-striped table-bordered">
      <thead class="text-center">
        <th>Activity Name</th>
        <th>Coach Fee</th>
      </thead>
      <tbody>
        <ng-container *ngFor="let activity of coach.activity; let i = index">
          <tr>
            <td>
              {{activity.activity_name || '-'}}
            </td>
            <td>
              {{activity.coach_fee || 0}}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div>
      <button class="btn btn-primary mt-3" (click)="onBack()">Back</button>
    </div>
  </div>
</div>

<ng-template #editCoach let-modal let-close="close">
  <div [formGroup]="modalForm" class="row modal-edit">
    <!-- <div class="col-md-3">
      <app-select-academic-year-only
          (academicYearChanged)="onChangeAcademicYearModal($event)">
      </app-select-academic-year-only>
    </div> -->
    <div class="col-md-4">
        <app-select-school-level-relation-v2
            [academic_year]="null"
            (schoolLevelRelationChanged)="onChangeSchoolLevelModal($event)"
            [with_academic_year]="true">
        </app-select-school-level-relation-v2>
    </div>
    <!-- <div class="d-grid pt-4" style="max-width: 600px;">
      <span style="font-size: 14px; font-weight: bold; color: #333;">Coach Username</span>
      <input placeholder="Coach Name"
              (change)="trackAddCoachChanges()"
              class="form-control p-3 fs-14 border-1 rounded h-25 w-100"
              style="outline: none;" formControlName="username">
    </div>
    <div class="d-grid" style="max-width: 600px;">
        <span style="font-size: 14px; font-weight: bold; color: #333;">Coach Name</span>
        <input placeholder="Coach Name"
                (change)="trackAddCoachChanges()"
                class="form-control p-3 fs-14 border-1 rounded h-25 w-100"
                style="outline: none;" formControlName="fullname">
    </div>
    <div class="d-grid">
        <span style="font-size: 14px; font-weight: bold; color: #333;">Coach Email</span>
        <input placeholder="Coach Email"
                (change)="trackAddCoachChanges()"
                class="form-control p-3 fs-14 border-1 rounded h-25 w-100"
                style="outline: none;" formControlName="email">
    </div> -->
    <mat-tab-group [formGroup]="modalForm">
      <mat-tab label="{{ 'Coach' | translate }}">
          <div>
              <div class="d-grid mt-3 mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Photo Profile' | translate }}</span>
                  <img style="width: 100px; height: 100px" id="" [src]="imageSrc" alt="profile image" />
                  <input type="file" (change)="readURL($event)">
              </div>
              <div class="d-grid mt-3 mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Username' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                  <input placeholder="{{ 'Coach Name' | translate }}"
                          (change)="trackAddCoachChanges()"
                          class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                          style="outline: none;" formControlName="username">
              </div>
              <div class="d-grid mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Name' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                  <input placeholder="{{ 'Coach Name' | translate }}"
                          (change)="trackAddCoachChanges()"
                          class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                          style="outline: none;" formControlName="fullname">
              </div>
              <div class="d-grid mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Email' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                  <input placeholder="{{ 'Coach Email' | translate }}"
                          type="email"
                          email
                          (change)="trackAddCoachChanges()"
                          class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                          style="outline: none;" formControlName="email">
                  <div *ngIf="!this.modalForm.get('email')?.valid" style="font-size: 14px; color: red;" class="mb-2">{{ 'Email not valid' | translate }}</div>
              </div>
          </div>
      </mat-tab>
      <mat-tab label="{{ 'Personal Data' | translate }}">
          <div>
              <div class="d-grid mt-3 mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Date of Birth' | translate }}<span style="font-size: 16px; color: rgb(190, 0, 0);">*</span></span>
                  <input type="date" (change)="trackAddCoachChanges()" class="form-control" placeholder="{{ 'Start date' | translate }}" formControlName="date_of_birth">
              </div>
              <div class="d-grid mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Place of Birth' | translate }}</span>
                  <input placeholder="{{ 'Input place of birth' | translate }}"
                          type="text"
                          class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                          style="outline: none;" formControlName="place_of_birth">
              </div>
              <div class="d-grid mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Gender' | translate }}</span>
                  <ng-select
                          formControlName = "gender"
                          [placeholder]="modalForm.get('gender')?.value ? '' : 'Select gender'"
                          [items]="genderList"
                          class="selector-style">
                      <ng-template ng-option-tmp let-item="item">
                          <div class="custom-option-style" title="{{item}}">{{item}}</div>
                      </ng-template>
                  </ng-select>
              </div>
              <div class="d-grid mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Marital Status' | translate }}</span>
                  <ng-select
                          formControlName = "marital_status"
                          [placeholder]="modalForm.get('marital_status')?.value ? '' : 'Select status'"
                          [items]="maritalStatusList"
                          class="selector-style">
                      <ng-template ng-option-tmp let-item="item">
                          <div class="custom-option-style" title="{{item}}">{{item}}</div>
                      </ng-template>
                  </ng-select>
              </div>
              <div class="d-grid mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Religion' | translate }}</span>
                  <ng-select
                          formControlName = "religion_id"
                          [placeholder]="modalForm.get('religion_id')?.value ? '' : 'Select religion'"
                          [items]="religionList"
                          bindLabel="religion_name"
                          bindValue="religion_id"
                          class="selector-style">
                      <ng-template ng-option-tmp let-item="item">
                          <div class="custom-option-style" title="{{item.religion_name}}">{{item.religion_name}}</div>
                      </ng-template>
                  </ng-select>
              </div>
              <div class="d-grid mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Nationality' | translate }}</span>
                  <ng-select
                          formControlName = "nationality_id"
                          [placeholder]="modalForm.get('nationality_id')?.value ? '' : 'Select nationality'"
                          [items]="nationalityList"
                          bindLabel="nationality_name"
                          bindValue="nationality_id"
                          class="selector-style">
                      <ng-template ng-option-tmp let-item="item">
                          <div class="custom-option-style" title="{{item.nationality_name}}">{{item.nationality_name}}</div>
                      </ng-template>
                  </ng-select>
              </div>
              <div class="d-grid mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Nationality Type ID' | translate }}</span>
                  <ng-select 
                          formControlName = "nationality_id_type"
                          [placeholder]="modalForm.get('nationality_id_type')?.value ? '' : 'Select nationality type'"
                          [items]="nationalityTypeList"
                          class="selector-style">
                      <ng-template ng-option-tmp let-item="item">
                          <div class="custom-option-style" title="{{item}}">{{item}}</div>
                      </ng-template>
                  </ng-select>
              </div>
              <div class="d-grid mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Nationality Type Number' | translate }}</span>
                  <input placeholder="{{ 'Input nationality type number' | translate }}"
                          type="text"
                          class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                          style="outline: none;" formControlName="nationality_id_number">
              </div>
              <div class="d-grid mb-3">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'NPWP' | translate }}</span>
                  <input placeholder="{{ 'Input NPWP' | translate }}"
                          type="text"
                          class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                          style="outline: none;" formControlName="npwp">
              </div>
          </div>
      </mat-tab>
      <mat-tab label="{{ 'Contact Information' | translate }}">
          <div class="d-grid mt-3 mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Phone Number' | translate }}</span>
              <input placeholder="{{ 'Input phone number' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="phone_number">
          </div>
          <div class="d-grid mt-3 mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Cellular Number' | translate }}</span>
              <input placeholder="{{ 'Input phone number' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="cellular_number">
          </div>
          <div class="d-grid mt-3 mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Alternative Email Address' | translate }}</span>
              <input placeholder="{{ 'Input phone number' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="alternative_email_address">
          </div>
      </mat-tab>
      <mat-tab label="{{ 'Address Information' | translate }}">
          <div class="d-grid mt-3 mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Country' | translate }}</span>
              <ng-select
                      [placeholder]="modalForm.get('country_id')?.value ? '' : 'Select country'"
                      formControlName = "country_id"
                      (change)="getProvince()"
                      [items]="countryList"
                      bindLabel="country_name"
                      bindValue="country_id"
                      class="selector-style">
                  <ng-template ng-option-tmp let-item="item">
                      <div class="custom-option-style" title="{{item.country_name}}">{{item.country_name}}</div>
                  </ng-template>
              </ng-select>
          </div>
          <div class="d-grid mt-3 mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Province' | translate }}</span>
              <ng-select
                      [placeholder]="modalForm.get('province_id')?.value ? '' : 'Select province'"
                      formControlName = "province_id"
                      [items]="province"
                      bindLabel="province_name"
                      bindValue="province_id"
                      class="selector-style">
                  <ng-template ng-option-tmp let-item="item">
                      <div class="custom-option-style" title="{{item.province_name}}">{{item.province_name}}</div>
                  </ng-template>
              </ng-select>
          </div>
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'City' | translate }}</span>
              <input placeholder="{{ 'Input city' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="city">
          </div>
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Full Address' | translate }}</span>
              <textarea placeholder="{{ 'Input full address' | translate }}"
                        class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                        style="outline: none; resize: none;" 
                        rows="4"
                        formControlName="full_address"></textarea>
          </div>                
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Postal Code' | translate }}</span>
              <input placeholder="{{ 'Input postal code' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="postal_code">
          </div>
      </mat-tab>
      <mat-tab label="{{ 'Finance Information' | translate }}">
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Fee/Day' | translate }}</span>
              <input placeholder="{{ 'Input coach fee' | translate }}"
                      type="text"
                      mask="separator.0" thousandSeparator="."
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="coach_fee">
          </div>
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Bank Account' | translate }}</span>
              <input placeholder="{{ 'Input bank account name' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="bank_account">
          </div>
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Bank Account Number' | translate }}</span>
              <input placeholder="{{ 'Input bank account number' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="account_number">
          </div>
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Account Holder Name' | translate }}</span>
              <input placeholder="{{ 'Input bank account holder name' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="account_holder_name">
          </div>
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Bank Office Branch' | translate }}</span>
              <input placeholder="{{ 'Input bank office branch' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="bank_office_brand">
          </div>
      </mat-tab>
      <mat-tab label="{{ 'Institute Information' | translate }}">
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Institute Name' | translate }}</span>
              <input placeholder="{{ 'Input institute name' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="institute_name">
          </div>
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Institute Office Number' | translate }}</span>
              <input placeholder="{{ 'Input institute office number' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="institute_office_number">
          </div>
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Institute Email Address' | translate }}</span>
              <input placeholder="{{ 'Input institute email address' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="institute_email_address">
          </div>
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Institute Address' | translate }}</span>
              <textarea placeholder="{{ 'Input institute address' | translate }}"
                      type="text"
                      rows="4"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none; resize: none;" formControlName="institute_address"></textarea>
          </div>
          <div class="d-grid mb-3">
              <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'Coach Remarks' | translate }}</span>
              <input placeholder="{{ 'Input coach remarks' | translate }}"
                      type="text"
                      class="form-control p-3 fs-14 border-1 rounded h-100 w-100"
                      style="outline: none;" formControlName="coach_remarks">
          </div>
      </mat-tab>
  </mat-tab-group>
    <div class="row justify-content-end p-3">
      <button class="col-md-2 btn btn-success mt-3" [disabled]="disabledEditCoach" *ngIf="auth.permissions['SCHOOL_PROGRAM_COACH_EDIT']" (click)="onEditCoach()">Save</button>
    </div>
  </div>
</ng-template>